<template>
  <a href="/"><img class="logo" :src="src" alt="Rees Solutions"></a>
</template>

<script>
export default {
  name: 'Logo',
  data () {
    return {
      src: '/static/rees-solutions-logo.svg'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.logo {
  width: 176px;
  height: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue